import type {
  CategorySection as CategorySectionType,
  ProductCard as ProductCardType,
} from '@repo/supergraph/roundup/base/types';

export const createOfferOrderMap = (offers: ProductCardType[]): Map<string, number> => {
  const offerOrderMap = new Map<string, number>();
  offers.forEach((offer, index) => {
    offerOrderMap.set(offer.marketplaceEntity.id, index);
  });
  return offerOrderMap;
};

export const filterProductCardsByOffers = (
  productCards: ProductCardType[],
  offers: ProductCardType[],
): ProductCardType[] => {
  return productCards.filter(card =>
    offers.some(offer => offer.marketplaceEntity.id === card.marketplaceEntity.id),
  );
};

export const sortProductCardsByOfferOrder = (
  productCards: ProductCardType[],
  offerOrderMap: Map<string, number>,
): ProductCardType[] => {
  return productCards.slice().sort((a, b) => {
    const orderA = offerOrderMap.get(a.marketplaceEntity.id) ?? Infinity;
    const orderB = offerOrderMap.get(b.marketplaceEntity.id) ?? Infinity;
    return orderA - orderB;
  });
};

export const sortSectionsByFirstCardOrder = (
  sections: CategorySectionType[],
  offerOrderMap: Map<string, number>,
): CategorySectionType[] => {
  return sections.sort((a, b) => {
    const firstCardOrderA = offerOrderMap.get(a.productCards[0].marketplaceEntity.id) ?? Infinity;
    const firstCardOrderB = offerOrderMap.get(b.productCards[0].marketplaceEntity.id) ?? Infinity;
    return firstCardOrderA - firstCardOrderB;
  });
};
